import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { FILE_STORAGE_API, API_URL, FILE_STORAGE } from '../../../../../constants'
import { triggerPopup, triggerPopupActionBG } from '../../../../../actions/backdrop'
import {
  uploadFileToOrder, deleteFileFromOrder, isFileReady } from '../../../../../actions/orders'
import Dropzone from '../../../../../shared/components/Dropzone'
import Gallery from '../../../../../shared/components/Gallery'
import Confirm from '../../../../../shared/components/Confirm'
import Portal from '../../../../../shared/components/Portal'
import HandleFilesModal from '../../../../../shared/modals/HandleFilesModal'
import async from 'async'
import { translation } from '../../../../../utils/helpers'

import Panel from '../../../../../shared/elements/panel'
import RemoveButton from '../../../../../shared/elements/removeButton'
import Button from '../../../../../shared/elements/button'
import Icon from '../../../../../shared/elements/icon'
import Inline from '../../../../../shared/elements/inline'

import { MainMenuIcons } from '../../../../../shared/elements/icons'

class Files extends PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      confirmFileDelete: {
        confirm: false,
        file: null
      },
      handleFilesPopupOpen: false,
      upload: {
        loading: false,
        errors: []
      }
    }
    this.renderContent = this.renderContent.bind(this)
    this.updateImages = this.updateImages.bind(this)
    this.togglePopup = this.togglePopup.bind(this)
  }
  componentDidMount () {
    this.checkFileTimer = setInterval(this.updateImages, 3000)
  }

  updateImages () {
    if (Object.keys(this.props.order).length === 0) return null
    if (window.location.hostname === 'localhost') return null
    let files = [...this.props.order.OrderFiles]
    let order = { ...this.props.order }
    let readyChecks = 0
    for (let i = 0; i < files.length && readyChecks < 3; i++) {
      if (files[i].IsImage) {
        let img = files[i]
        if (img.IsFinishedLoading === false) {
          // Check with api if file is ready.
          readyChecks++
          this.props.isFileReady(img.OrderFileID).then((res) => {
            if (res.data.FileReady === true) {
              let append = '?preventCache=' + Math.random() * 10
              img.IsFinishedLoading = true
              img.ThumbURL = res.data.ThumbURL + append
              img.FileURL = res.data.FileURL + append
              order.OrderFiles[i] = img
              this.props.saveSingleValue('OrderFiles', order.OrderFiles)
            }
          })
        }
      }
    }
  }

  componentWillMount () {
  }
  componentWillUnmount () {
    clearInterval(this.checkFileTimer)
  }

  togglePopup () {
    this.props.triggerPopup(!this.state.handleFilesPopupOpen)
    this.setState({
      handleFilesPopupOpen: !this.state.handleFilesPopupOpen
    })
  }

  renderContent () {
    let { errors } = this.state.upload
    let isCustomer = this.props.auth.user.CustomerId !== '-1'
    // Delete file
    const deleteFile = (file) => {
      let confirm = {
        confirm: true,
        file: file
      }
      this.setState({
        confirmFileDelete: confirm
      })
    }

    // Show delete
    let showDelete = true
    if (isCustomer) {
      if (!this.props.order.IsDraft) {
        showDelete = false
      }
    }

    // Render image
    const renderImage = (image, index) => {
      if (image.SharingType === 0 && !image.IsCurrentShopFile) return null
      let url = FILE_STORAGE + image.ThumbURL
      let fullUrl = FILE_STORAGE + image.FileURL
      return (
        <div key={index} className='file-image'>
          <Inline block alignChildren='top' spacing={0}>
            {!isCustomer && image.SharingType === 1 && <Icon icon={MainMenuIcons.Customers_Black} size='s' injectSvg />}
            {(showDelete && image.IsDeletable) && <div className='file-delete'><RemoveButton onClick={() => deleteFile(image)} size='s' /></div>}
          </Inline>
          <div className='divImg'><a href={fullUrl} data-lightbox='gallery' data-title={image.FileName}><img src={url} /></a></div>
        </div>
      )
    }
    // Render file
    const renderFile = (file, index) => {
      // let fileUrl = file.FileURL.replace('API/', '')
      if (file.ActualFileName === null || (file.SharingType === 0 && !file.IsCurrentShopFile)) return null
      let newFileUrl = FILE_STORAGE_API + '/FileService/DownloadNoHeader?fileName=' + file.FileNameWithFolders + '&token=' + encodeURIComponent(this.props.auth.user.Token)
      let thumbUrl = API_URL + '/FileService/GetIcon?fileName=' + file.FileName
      const fileError = () => {
        window.toastr.error(translation('15191'), translation('216'))
      }
      // Return
      return (
        <div key={index} className='file-document clearfix'>
          <img className='file-icon' alt='icon' src={thumbUrl} />
          {file.FileExists ? (<a target='_BLANK' href={newFileUrl}>
            {file.FileName}
          </a>) : (
            <a onClick={fileError}>
              {file.FileName}
            </a>
          )}
          <Inline alignChildren='top' spacing={0}>
            {!isCustomer && file.SharingType === 1 && <Icon icon={MainMenuIcons.Customers_Black} size='s' injectSvg />}
            {(showDelete && file.IsDeletable) && <div className='file-delete'><RemoveButton onClick={() => deleteFile(file)} size='s' /></div>}
          </Inline>
        </div>
      )
    }
    // On drop
    const onDrop = () => {
      this.setState({ upload: { ...this.state.upload, errors: [] } })
    }
    // On drop accepted
    const onDropAccepted = (files) => {
      let newErrors = []
      this.setState({
        upload: {
          ...this.state.upload,
          loading: true,
          errors: []
        }
      })
      async.each(files, (file, cb) => {
        // Upload each file
        this.props.uploadFileToOrder(file, this.props.order.Id).then((res) => {
          cb()
        }, () => {
          newErrors.push(translation('1207') + ': ' + file.name + ' ' + translation('13406') + '.')
          cb()
        })
      }, () => {
        if (newErrors.length !== 0) {
          this.setState({
            upload: {
              ...this.state.upload,
              errors: this.state.upload.errors.concat(newErrors)
            }
          })
        }
        this.setState({
          upload: {
            ...this.state.upload,
            loading: false
          }
        })
        // Save order first
        let mock = {
          preventDefault: () => { }
        }
        this.props.saveWorkcard(mock).then(() => {
          this.props.onUpdateOrder()
        }, () => {
          this.props.onUpdateOrder()
        })
      })
    }
    // On drop rejected
    const onDropRejected = (files) => {
      let newErrors = []
      files.map((val, index) => {
        newErrors.push(translation('1207') + ': ' + val.name + ' ' + translation('13405') + '.')
      })
      this.setState({ upload: { ...this.state.upload, errors: newErrors } })
    }
    // Render error
    const renderError = (error, index) => {
      return <p key={index}>{error}</p>
    }
    // Other files
    let otherFiles = [...this.props.order.OrderFiles]
    otherFiles = otherFiles.filter((val, index) => {
      return !val.IsImage
    })
    // imgFiles
    let imgFiles = [...this.props.order.OrderFiles]
    imgFiles = imgFiles.filter((val, index) => {
      return val.IsImage
    })

    // Confirm delete
    const onPortalClose = () => {
      let confirm = {
        confirm: false,
        file: null
      }
      this.setState({
        confirmFileDelete: confirm
      })
    }
    const onConfirm = () => {
      let file = this.state.confirmFileDelete.file
      let confirm = {
        confirm: false,
        file: null
      }
      this.setState({ confirmFileDelete: confirm }, () => {
        this.props.deleteFileFromOrder(file)
          .then(_ => this.props.onUpdateOrder())
          .catch(err => {
            if (err.response && err.response.status === 400) {
              const { dictionaryKey, translationParams } = err.response.data
              window.toastr.error(translation(dictionaryKey, translationParams), translation('216'))
            }
          })
      })
    }

    // Render
    let isMultipleUpload = true
    return (
      <div>
        {errors.length !== 0 && <div className='alert alert-danger'>{errors.map(renderError)}</div>}
        {this.props.disabled !== true && (
          <Dropzone
            onDrop={onDrop}
            onDropAccepted={onDropAccepted}
            onDropRejected={onDropRejected}
            multiple={isMultipleUpload}
            includeCircles={false}>
            <p>{translation('13397')}</p>
          </Dropzone>
        )}
        <div className='files_inner'>
          <div>
            {otherFiles.map(renderFile)}
          </div>
          <Gallery files={imgFiles} renderImage={renderImage} />
        </div>
        {!isCustomer && <Button style='secondary' labelText={translation(16812)} onClick={this.togglePopup} />}
        {this.state.confirmFileDelete.confirm && (
          <Portal className='deleteModal' onPortalClose={onPortalClose}>
            <Confirm confirm={onConfirm} notConfirm={onPortalClose} />
          </Portal>
        )}
        {this.state.handleFilesPopupOpen && (
          <HandleFilesModal
            onClose={this.togglePopup}
            show={this.state.handleFilesPopupOpen}
            orderId={this.props.order.Id} />
        )}
      </div>
    )
  }

  render () {
    if (!this.props.whitebox) {
      return (
        <div>
          {this.renderContent()}
        </div>
      )
    }

    return (
      <Panel title={translation('1043')} dataCol='files'>
        {this.renderContent()}
      </Panel>
    )
  }
}

Files.defaultProps = {
  datacol: '',
  hideContent: false,
  editAllowed: true,
  whitebox: true
}

Files.propTypes = {
  onUpdateOrder: PropTypes.func.isRequired,
  order: PropTypes.object.isRequired,
  auth: PropTypes.object.isRequired
}

Files.contextTypes = {
  router: PropTypes.object.isRequired
  // t: React.PropTypes.func.isRequired
}

function mapStateToProps (state) {
  return {
    orderTypes: state.common.enums.orderTypes,
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  triggerPopup,
  triggerPopupActionBG,
  isFileReady,
  uploadFileToOrder,
  deleteFileFromOrder
})(Files)



// WEBPACK FOOTER //
// ./src/app/pages/Orders/Order/NewWorkCard/Files/index.js